import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Invitation } from '../../interfaces/invitations/invitation.interface';
import { InvitationPostBody } from '@shared/interfaces';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { getAppId } from '@shared/utils';

@Injectable({ providedIn: 'root' })
export class InvitationHttpService {
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.api;
  private readonly _tenantFacade = inject(TenantFacadeService);
  private readonly appId = getAppId();

  private readonly apiDomain = this._tenantFacade.tenantApiPrefix;

  public createInvitation(body: InvitationPostBody) {
    return this._http.post<Invitation>(
      `${this._apiUrl}/${this.apiDomain()}/${this.appId()}/invitations/`,
      body,
    );
  }

  public getInvitations() {
    return this._http.get<Invitation[]>(
      `${this._apiUrl}/${this.apiDomain()}/${this.appId()}/invitations/`,
    );
  }

  public deleteInvitation(invitationId: number) {
    return this._http.delete<void>(
      `${this._apiUrl}/${this.apiDomain()}/${this.appId()}/invitations/${invitationId}/`,
    );
  }

  public resendInvitation(invitationId: number) {
    return this._http.post<void>(
      `${this._apiUrl}/${this.apiDomain()}/${this.appId()}/invitations/${invitationId}/resend/`,
      {},
    );
  }
}
